export enum ClaimHistoryTagEnum {
    Flow = 1,
    System = 2,
    Sac = 3,
    Internal = 4,
}